import script from "./PhoneVerificationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneVerificationForm.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneVerificationForm.vue?vue&type=style&index=0&id=275a7516&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275a7516"]])

export default __exports__